export const environment = {
  name: "AXIS for Business Partners",
  title: "AXIS for Business Partners",
  version: "2.2",
  businessPartnerMailAuthRole: "RA115-G-GAMA_DX-AXIS-BP-EXT",
  businessPartnerDomainAuthRole: "SG_GAMA_DX-AXIS-Business-Partners",
  authRole: "SG_GAMA_DX-AXIS-Business-Partners",
  production: true,
  businessPartnerMode: true,
  enableServiceMetricsWidget: false,
  chatBotVersion: "3.0",
  powerbiworkspace: "0103bd38-4767-4f4e-bdec-5ea97da4d5e9",
  storageBlobHost: 'datalsservicecopilotwe.blob.core.windows.net',
  msalConfig: {
    auth: {
      clientId: '05a3a7e8-53f4-4e64-b116-3d86e037a8d9',
      authority: 'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  backendId: "33272ae5-4a4b-412d-bfef-0bf44fbb3a1e",
  modals: {
    fleet: {
      reportId: "258025ab-e735-4113-a4fc-ceb83e59568f",
      groupId: "6ed89fc2-3403-4653-b804-9845752de58a",
      autocheck: {
        CC: { pageid: "7f9beb467160756d2be1" },
        IA: { pageid: "ccdd33249d764d0ebe04" },
        CI: { pageid: "a3c754f54a0a3ebd40b7" },
        SH: { pageid: "379876eae257b70ab727" },
        SHC: { pageid: "1a1cfb9a8eebe6c3127e" },
        VMM: { pageid: "abb2e6e07992bd374d4a" },
        DL: { pageid: "85059ac11807011050b2" },
      },
      maintenance: { pageid: "5217a54ac8a05e0954fc" },
      events: { pageid: "a7dd82b6a1242c115bac" },
      eventlog: { pageid: "544762508a1d9951f242"}
    }
  }
};